/**
 * Auth-aware routes.
 *   - /access/:token and /admin are always reachable (they handle their own auth).
 *   - When signed in: the game at "/", plus /history and /account.
 *   - When not signed in: everything falls back to the "access link required" page.
 * Auth (and history/admin wiring) added in task #11; deploy/infra are tasks #8–#10.
 */
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { GamePage } from "./GamePage";
import { AccessPage } from "./pages/AccessPage";
import { AdminPage } from "./pages/AdminPage";
import { ShareLinkPage } from "./pages/ShareLinkPage";
import { HistoryPage } from "./pages/HistoryPage";
import { AccountPage } from "./pages/AccountPage";
import { NeedAccessPage } from "./pages/NeedAccessPage";

export function App() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div className="grid min-h-svh place-items-center bg-paper text-ink-500">Loading…</div>;
  }

  return (
    <Routes>
      <Route path="/access/:token" element={<AccessPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/admin/share/:id" element={<ShareLinkPage />} />
      {user ? (
        <>
          <Route path="/" element={<GamePage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      ) : (
        <>
          <Route path="/" element={<NeedAccessPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      )}
    </Routes>
  );
}
